import React from 'react';

const topSection = () => {
    return (
        <section  className="section-darker section-downward">
            <div className="container">
                <h2>React Modal Example</h2>
                <p>This is a React.js version of the <a href="/portfolio/modal.html">JavaScript modal</a> and is in the process of being built. Currently, the elements have been moved into components and the search has been moved into React.</p>
                <p>The code for this can be found on <a href="https://github.com/hhsaito/react-bios">Github</a>.</p>
            </div>
        </section>
    );
}

export default topSection;